import { cn } from '@/utils/cn';
interface Props {
  className?: string;
}
const CarouselSkeleton = ({
  className
}: Props) => {
  return <div className={cn('flex h-full w-full gap-2 overflow-hidden lg:gap-4', className)} data-sentry-component="CarouselSkeleton" data-sentry-source-file="skeleton.tsx">
            {Array(8).fill(null).map((_, i) => <div key={i} className='h-40 w-30 shrink-0 animate-pulse rounded bg-[var(--landing-skeleton-pulse)] lg:h-[290px] lg:w-[217px]' />)}
        </div>;
};
export default CarouselSkeleton;